<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <SatsCards></SatsCards>
                <div class="row">
                    <div class="col-lg-12">
                        <form @submit.prevent="submitForm">
                            <div class="card">
                                <div class="p-3 pb-0 card-header">
                                    <div class="d-flex flex-column flex-md-row justify-content-between">

                                        <!-- Sección Izquierda (Título) -->
                                        <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                            <h6 class="mb-2 ms-2">Registrar Horas</h6>
                                        </div>

                                        <!-- Sección Derecha (Botón) -->
                                        <div v-if="!hasAutomaticReports"
                                            class="col-12 col-md-4 text-center text-md-end mt-2 mt-md-0">
                                            <button type="submit" class="btn btn-warning">Guardar</button>
                                        </div>

                                    </div>
                                    <div class="d-flex flex-column flex-md-row justify-content-center">
                                        <!-- Sección Central (Semana con íconos) -->
                                        <div
                                            class="col-12 col-md-4 d-flex align-items-center justify-content-center gap-2">
                                            <i class="ni ni-bold-left text-warning text-sm opacity-10"
                                                @click="previousWeek" style="cursor: pointer;"></i>
                                            <h6 class="mb-0 text-nowrap">Semana del {{ formatDate(startOfWeek) }} - {{
                                                formatDate(endOfWeek) }}</h6>
                                            <i class="ni ni-bold-right text-warning text-sm opacity-10"
                                                @click="nextWeek" style="cursor: pointer;"></i>
                                        </div>
                                    </div>
                                    <div v-if="hasAutomaticReports"
                                        class="d-flex flex-column flex-md-row justify-content-center mt-4">
                                        <p>
                                            <b>Tu reporte de horas está siendo generado automáticamente, no es necesario
                                                que captures horas.
                                            </b>
                                        </p>
                                    </div>
                                    <div v-if="closedPeriod"
                                        class="d-flex flex-column flex-md-row justify-content-center mt-4">
                                        <p>
                                            <b>
                                                Este periodo de tiempo se encuentra cerrado, ya NO puedes registrar
                                                horas.
                                            </b>
                                        </p>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div v-if="!hasAutomaticReports && !closedPeriod">
                                        <div class="row justify-content-center">
                                            <div class="col-lg-3">
                                                <div class="mb-3 text-center">
                                                    <label for="client" class="form-label">Cliente</label>
                                                    <select id="client" v-model="selectedClient"
                                                        @change="fetchUserProjects" class="form-control" required>
                                                        <option value="" disabled>Selecciona un cliente</option>
                                                        <option v-for="client in clients" :key="client.client_id"
                                                            :value="client.client_id">
                                                            {{ client.client }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-lg-3">
                                                <div class="mb-3 text-center">
                                                    <label for="project" class="form-label">Proyecto</label>
                                                    <select id="project" v-model="selectedProject"
                                                        :disabled="!selectedClient" class="form-control" required>
                                                        <option value="" disabled>Selecciona un proyecto</option>
                                                        <option v-for="project in projects" :key="project.project_id"
                                                            :value="project.project_id">
                                                            {{ project.identifier }} - {{ project.project }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table border-0">
                                                <thead>
                                                    <tr class="border-0">
                                                        <th class="border-0 text-start"
                                                            style="min-width: 80px; width: 10%;">Día</th>
                                                        <th class="border-0 text-start" style="width: 5%;">
                                                            Horas:</th>
                                                        <th class="border-0 text-start" style="width: 5%;">
                                                            Extra:</th>
                                                        <th v-if="showOnSite" class="border-0 text-center"
                                                            style="min-width: 100px; width: 12%;">
                                                            <div class="d-flex align-items-center">
                                                                <div class="mb-0">En Planta?</div>
                                                                <div class="form-check form-switch mb-1 ms-1">
                                                                    <input v-model="selectAllOnSite"
                                                                        @change="toggleAll('onSite')"
                                                                        class="mt-1 form-check-input" type="checkbox" />
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th class="border-0 text-start"
                                                            style="min-width: 200px; width: 20%;">
                                                            Actividad
                                                        </th>
                                                        <th class="border-0 text-start"
                                                            style="min-width: 200px; width: 25%;">
                                                            Notas
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(date, index) in weekDates" :key="date">
                                                        <!-- Día -->
                                                        <td class="border-0">
                                                            <strong>{{ getDayName(date) }}</strong> <br>
                                                            <small class="text-muted">{{ formatDate(date) }}</small>
                                                        </td>

                                                        <!-- Horas -->
                                                        <td class="border-0">
                                                            <input v-model="hours[index]" type="number" min="0.25"
                                                                step=".01" class="form-control text-center"
                                                                placeholder="Hrs"
                                                                style="max-width: 100%; min-width: 50px;">
                                                        </td>

                                                        <!-- Horas Extra -->
                                                        <td class="border-0">
                                                            <input v-model="extraHours[index]" type="number" min="0.25"
                                                                step=".01" class="form-control text-center"
                                                                placeholder="Hrs"
                                                                style="max-width: 100%; min-width: 50px;">
                                                        </td>

                                                        <!-- En Sitio -->
                                                        <td v-if="showOnSite"
                                                            class="border-0 text-start jusfity-content-left">
                                                            <div class="form-check form-switch mt-2">
                                                                <input v-model="onSite[index]"
                                                                    class="mt-1 form-check-input ms-2"
                                                                    type="checkbox" />
                                                            </div>
                                                        </td>

                                                        <!-- Actividad -->
                                                        <td class="border-0">
                                                            <select v-model="activity[index]" class="form-control">
                                                                <option value="" disabled>Selecciona una actividad
                                                                </option>
                                                                <option v-for="act in activities" :key="act.activity_id"
                                                                    :value="act.activity_id">
                                                                    {{ act.activity }}
                                                                </option>
                                                            </select>
                                                        </td>

                                                        <!-- Notas -->
                                                        <td class="border-0">
                                                            <input v-model="notes[index]" type="text"
                                                                class="form-control" placeholder="Notas">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="p-3 pb-0 card-header">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 class="mb-2 ms-2">Registros de la semana Semana del {{
                                            formatDate(startOfWeek)
                                            }}
                                            al
                                            {{ formatDate(endOfWeek) }}</h6>
                                    </div>
                                    <div v-if="!hasAutomaticReports">
                                        <button class="btn btn-warning " @click="sendToAuthorize">Enviar a
                                            Autorizar</button>
                                    </div>


                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th colspan="3"><b>Total Horas</b></th>
                                                <th colspan="2" v-for="date in weekDates" :key="date.key">
                                                    {{ formatShortDate(formatDate2(date)) }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>Totales</th>
                                                <th>Regulares</th>
                                                <th>Extra</th>
                                                <template v-for="date in weekDates" :key="date.key">
                                                    <th>HR</th>
                                                    <th>HE</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody v-if="week_summary">
                                            <tr>
                                                <td><b>{{ week_summary.total_hours }}</b></td>
                                                <td><b>{{ week_summary.regular_hours }}</b></td>
                                                <td><b>{{ week_summary.extra_hours }}</b></td>

                                                <template v-for="date in weekDates" :key="date.key">
                                                    <td>
                                                        {{ week_summary?.hours?.[formatDate2(date)]?.hn ?? '0' }}
                                                    </td>
                                                    <td>
                                                        {{ week_summary?.hours?.[formatDate2(date)]?.he ?? '0' }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="table-responsive mt-4">
                                    <TimeRecords :startDate="startOfWeek" :endDate="endOfWeek">
                                    </TimeRecords>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, watch, onMounted, ref } from 'vue';
import axios from 'axios';
import SatsCards from './components/SatsCards.vue';
import TimeRecords from './components/forms/TimeRecords.vue';

const API_BASE_URL = process.env.VUE_APP_BASE_URL;
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage

const selectedClient = ref("");
const selectedProject = ref("");
const clients = ref([]); // Lista de clientes desde la API
const projects = ref([]); // Lista de proyectos desde la API
const isNexon = ref(false)
const showOnSite = ref(true)

const week_summary = ref([])

const hasAutomaticReports = ref(false)

const hours = ref(Array(7).fill('')); // Horas por día
const extraHours = ref(Array(7).fill('')); // Horas extra por día
const onSite = ref(Array(7).fill(false)); // En sitio por día
const billable = ref(Array(7).fill(false)); // Facturable por día
const activity = ref(Array(7).fill('')); // Actividad por día
const notes = ref(Array(7).fill('')); // Nota por día

// Genera un array con las fechas de la semana
const weekDates = computed(() => {
    const dates = [];
    const startDate = new Date(startOfWeek.value);
    for (let i = 0; i < 7; i++) {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        dates.push(currentDate);
    }
    return dates;
});

// Computed para detectar si todos están seleccionados
const selectAllOnSite = computed({
    get: () => onSite.value.every(v => v),
    set: (val) => onSite.value = onSite.value.map(() => val)
});

const selectAllBillable = computed({
    get: () => billable.value.every(v => v),
    set: (val) => billable.value = billable.value.map(() => val)
});

// Método para alternar los checkboxes en masa
const toggleAll = (type) => {
    if (type === 'onSite') {
        onSite.value = onSite.value.map(() => selectAllOnSite.value);
    } else if (type === 'billable') {
        billable.value = billable.value.map(() => selectAllBillable.value);
    }
};

const verifyIsNexon = (clientId) => {
    if (clientId === 2) {
        isNexon.value = true
        showOnSite.value = false
    } else {
        showOnSite.value = true
    }
}

// Enviar datos al servidor
const submitForm = async () => {
    const formData = {
        client_id: selectedClient.value,
        project_id: selectedProject.value,
        days: weekDates.value.map((date, index) => ({
            date: formatDate2(date), // Fecha en formato "yyyy-mm-dd"
            total_hours: hours.value[index],
            total_extra_hours: extraHours.value[index],
            on_site: onSite.value[index],
            activity_id: activity.value[index],
            notes: notes.value[index],
        })).filter((day) => (day.total_hours > 0 || day.total_extra_hours > 0))
    };

    if (formData.days.length == 0) {
        alert('Porfavor Ingresa Horas')
        return
    }

    // Validar que todos los campos requeridos estén definidos (menos notes)
    const invalidDays = formData.days.filter(day =>
        !day.date ||
        (day.total_hours === undefined && day.total_extra_hours === undefined) ||
        day.activity_id === undefined ||
        day.activity_id === ''
    );

    if (invalidDays.length > 0) {
        alert('Hay registros con campos incompletos. Verifica que todas las columnas estén llenas.');
        return;
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/set-hour-records`, formData, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        // Asegurarse de que los datos se registren correctamente antes de intentar actualizar la tabla
        if (response.status === 200) {
            window.location.reload();
            alert('Horas Registradas');
        } else {
            console.error('Error en el servidor:', response.data);
        }
    } catch (error) {
        console.error('Error al registrar los tiempos:', error);
        // Verificar si hay respuesta del servidor
        if (error.response) {
            alert(error.response.data.msg || 'Ocurrió un error al registrar el evento.');
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

// Formatea la fecha como "dd/MM/yyyy"
function formatDate(date) {
    if (!date) return ''; // Evita errores si la fecha es null o undefined

    const d = new Date(date);
    if (isNaN(d.getTime())) return ''; // Verifica si la fecha es inválida

    return d.toLocaleDateString('es-ES', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    })
}

function formatDate2(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Asegura dos dígitos
    const day = String(d.getDate()).padStart(2, '0'); // Asegura dos dígitos
    return `${year}-${month}-${day}`; // Formato YYYY-MM-DD
}

const formatShortDate = (dateYMD) => {
    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
    const months = ['Enero', 'Feb', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Sept', 'Oct', 'Nov', 'Dic'];

    const [year, month, day] = dateYMD.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const weekDay = days[date.getDay()];
    const day2 = date.getDate();
    const month2 = months[date.getMonth()];

    return `${weekDay} ${day2} ${month2}`;
}

// Fecha actual reactiva
const currentDate = ref(new Date());

// Navegar a la semana anterior
const previousWeek = async () => {
    const date = new Date(currentDate.value);
    date.setDate(date.getDate() - 7); // Restar 7 días
    currentDate.value = date;

    await verifyIsLocked()
}

// Navegar a la semana siguiente
const nextWeek = async () => {
    const date = new Date(currentDate.value);
    date.setDate(date.getDate() + 7); // Sumar 7 días
    currentDate.value = date;

    await verifyIsLocked()
}

function getDayName(date) {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    return days[date.getDay()]; // getDay() devuelve un número (0 para Domingo, 1 para Lunes, etc.)
}


// Calcula el inicio y fin de la semana
const startOfWeek = computed(() => {
    const date = new Date(currentDate.value);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
});

const endOfWeek = computed(() => {
    const date = new Date(startOfWeek.value);
    date.setDate(date.getDate() + 6);
    return date;
});

const activities = ref([])

const fetchClientsByUserProjects = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/clients-user-projects`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        clients.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

const fetchUserProjects = async () => {
    if (!selectedClient.value) return;
    verifyIsNexon(selectedClient.value)
    try {
        const response = await axios.post(`${API_BASE_URL}/user-projects`, { client_id: selectedClient.value }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        projects.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

const fetchActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        activities.value = response.data; // Asigna los datos a variable `time_records`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const fetchUserWeekAbstract = async () => {

    const body = {
        start_date: formatDate2(startOfWeek.value),
        end_date: formatDate2(endOfWeek.value)
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/get-user-week-abstract`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status == 200 && response.data.success) {
            week_summary.value = response.data.data
        }
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const sendToAuthorize = async () => {

    if (confirm('¿Estás seguro de enviar a revisión para autorizar tu semana completa? Esta acción NO puede deshacerse')) {

        const body = {
            start_date: formatDate2(startOfWeek.value),
            end_date: formatDate2(endOfWeek.value)
        }

        try {
            const events_response = await axios.post(`${API_BASE_URL}/validate-week`, body, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            alert(events_response.data.msg)
            window.location.reload()
        } catch (error) {
            // Verificar si hay respuesta del servidor
            if (error.response) {
                alert(error.response.data.msg || 'Ocurrió un error al registrar el evento.');
            } else {
                alert('Error de conexión con el servidor.');
            }
        }
    }

}

const checkHasAutomaticReports = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/check-user-ar-status`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        hasAutomaticReports.value = response.data.has_automatic_reports
    } catch (error) {
        // Verificar si hay respuesta del servidor
        if (error.response) {
            console.error(error.response)
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

const closedPeriod = ref(false)

const verifyIsLocked = async () => {

    const body = {
        start_date: formatDate2(startOfWeek.value),
        end_date: formatDate2(endOfWeek.value)
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/verify-locked-week`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });

        closedPeriod.value = false
        
        if (response.data.is_locked > 0) {
            closedPeriod.value = true
        }

    } catch (error) {
        // Verificar si hay respuesta del servidor
        if (error.response) {
            console.error(error.response)
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

watch(() => [startOfWeek.value, endOfWeek.value], fetchUserWeekAbstract, { immediate: true })

onMounted(async () => {
    await checkHasAutomaticReports();
    await fetchClientsByUserProjects();
    await fetchActivities()
    await fetchUserWeekAbstract()
    await verifyIsLocked()
});

</script>